import {
    MapIcon,
    HomeIcon,
    UsersIcon,
    CalendarIcon,
    ChartPieIcon,
    BanknotesIcon,
    UserIcon,
    BuildingOfficeIcon,
    ClockIcon,
    TruckIcon,
    ShieldCheckIcon,
    ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';

import { RoleConstants } from '../constants/roles';

export const roleNavItems = {
    [RoleConstants.DRIVER]: [
        { name: 'Find Parking', href: '/find-parking', icon: TruckIcon, current: false },
        { name: 'Dashboard', href: '/', icon: ChartPieIcon, current: false },
        { name: 'Reservations', href: '/dashboard/reservations', icon: CalendarIcon, current: false },
        { name: 'Payment Methods', href: '/dashboard/payment-methods', icon: BanknotesIcon, current: false },
    ],
    [RoleConstants.FLEET_MANAGER]: [
        { name: 'Find Parking', href: '/find-parking', icon: TruckIcon, current: false },
        { name: 'Dashboard', href: '/', icon: HomeIcon, current: false },
        { name: 'Fleets', href: '/dashboard/fleet', icon: UsersIcon, current: false },
        { name: 'Reservations', href: '/dashboard/reservations', icon: CalendarIcon, current: false },
        { name: 'Payment Methods', href: '/dashboard/payment-methods', icon: BanknotesIcon, current: false },
    ],
    [RoleConstants.CARRIER_ADMIN]: [
        { name: 'Find Parking', href: '/find-parking', icon: TruckIcon, current: false },
        { name: 'Dashboard', href: '/', icon: HomeIcon, current: false },
        { name: 'Fleets', href: '/dashboard/fleet', icon: UsersIcon, current: false },
        { name: 'Insurance Policy', href: '/dashboard/insurance-policy', icon: ShieldCheckIcon, current: false },
        { name: 'Reservations', href: '/dashboard/reservations', icon: CalendarIcon, current: false },
        { name: 'Payment Methods', href: '/dashboard/payment-methods', icon: BanknotesIcon, current: false },
        { name: 'User Management', href: '/dashboard/account/users', icon: UserIcon, current: false },
    ],
    [RoleConstants.PROPERTY_MANAGER]: [
        { name: 'Dashboard', href: '/', icon: ChartPieIcon, current: false },
        { name: 'Payout Details', href: '/dashboard/payout-details', icon: BanknotesIcon, current: false },
        { name: 'My Properties', href: '/dashboard/my-properties', icon: MapIcon, current: false },
        { name: 'Reservations', href: '/dashboard/reservations', icon: CalendarIcon, current: false },
    ],
    [RoleConstants.HOST_ADMIN]: [
        { name: 'Dashboard', href: '/', icon: ChartPieIcon, current: false },
        { name: 'Payout Details', href: '/dashboard/payout-details', icon: BanknotesIcon, current: false },
        { name: 'My Properties', href: '/dashboard/my-properties', icon: MapIcon, current: false },
        { name: 'Reservations', href: '/dashboard/reservations', icon: CalendarIcon, current: false },
        { name: 'User Management', href: '/dashboard/account/users', icon: UserIcon, current: false },
    ],
    [RoleConstants.PARKPRO_ADMIN]: [
        { name: 'Dashboard', href: '/', icon: ChartPieIcon, current: false },
        { name: 'Property Amenities', href: '/dashboard/amenities', icon: UsersIcon, current: false },
        { name: 'Property Approval', href: '/dashboard/properties/approval', icon: MapIcon, current: false },
        { name: 'Account Approval', href: '/dashboard/accounts/approval', icon: UserIcon, current: false },
        { type: 'separator' },
        { name: 'All Properties', href: '/dashboard/super-admin/properties', icon: MapIcon, current: false },
        { name: 'All Reservations', href: '/dashboard/super-admin/reservations', icon: CalendarIcon, current: false },
        { name: 'All Insurance', href: '/dashboard/super-admin/coi', icon: ShieldCheckIcon, current: false },
        // PP-675 — review queue for carrier-submitted COIs, independent of
        // "All Insurance" above (same relationship this list has to "Account
        // Approval" vs. "All Users"). Built against PP-673/674's anticipated
        // contract — see client/src/pages/Admin/InsuranceApprovalTablePage.jsx.
        { name: 'Insurance Approval', href: '/dashboard/insurance/approval', icon: ClipboardDocumentCheckIcon, current: false },
    ],
    [RoleConstants.PARKPRO_SUPER_ADMIN]: [
        { name: 'Dashboard', href: '/', icon: ChartPieIcon, current: false },
        { name: 'Property Amenities', href: '/dashboard/amenities', icon: UsersIcon, current: false },
        { name: 'Property Approval', href: '/dashboard/properties/approval', icon: MapIcon, current: false },
        { name: 'Account Approval', href: '/dashboard/accounts/approval', icon: UserIcon, current: false },
        { name: 'All Users', href: '/dashboard/super-admin/users', icon: UsersIcon, current: false },
        { type: 'separator' },
        { name: 'All Properties', href: '/dashboard/super-admin/properties', icon: MapIcon, current: false },
        { name: 'All Fleets', href: '/dashboard/super-admin/fleets', icon: BuildingOfficeIcon, current: false },
        { name: 'All Reservations', href: '/dashboard/super-admin/reservations', icon: CalendarIcon, current: false },
        { name: 'All Insurance', href: '/dashboard/super-admin/coi', icon: ShieldCheckIcon, current: false },
        // PP-675 — see comment on the PARKPRO_ADMIN entry above.
        { name: 'Insurance Approval', href: '/dashboard/insurance/approval', icon: ClipboardDocumentCheckIcon, current: false },
        { name: 'Coming Soon', href: '/dashboard/super-admin/coming-soon', icon: ClockIcon, current: false },
    ],
};

export function mergeNavForRoles(rolesAll) {
    let navItems = [];
    if (rolesAll && Array.isArray(rolesAll) && rolesAll.length > 0) {
        const seen = new Set();
        rolesAll.forEach((r) => {
            (roleNavItems[r] || []).forEach((item) => {
                if (!seen.has(item.href)) {
                    navItems.push(item);
                    seen.add(item.href);
                }
            });
        });
    }
    if (navItems.length === 0) {
        return [{ name: 'Dashboard', href: '/', icon: HomeIcon }];
    }
    return navItems;
}

export const FOOTER_RULES = {
    showCompanySettingsRoles: new Set([
        RoleConstants.HOST_ADMIN,
        RoleConstants.CARRIER_ADMIN,
    ]),
};
